import { Node, mergeAttributes } from "@tiptap/core";

import type { Color } from "@corca/data";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    graph: {
      appendGraph: (position?: number, attrs?: object) => ReturnType;
    };
  }
}

export type GridType = 0 | 1 | 2 | 3 | 4 | 5;

/**
 * [xmin, xmax, ymin, ymax]
 */
export type GraphCoordsSystem = [number?, number?, number?, number?];

export type GraphNodeAttrs = {
  graphId: string;
  svg?: string;
  width: number;
  height: number;
  xMin: number;
  xMax: number;
  yMin: number;
  yMax: number;
  xAxisLabel?: string;
  yAxisLabel?: string;
  showGrid: boolean;
  showAxes: boolean;
  zoom: number;
  gridType: GridType;
  bgColor?: Color;
  gridColor?: Color;
  axesColor?: Color;
  axisLabels?: boolean;
  coordsSystem?: GraphCoordsSystem;
  axesVisible?: boolean;
};

export const GRAPH_WIDTH = 720;

export const GRAPH_HEIGHT = 450;

export const Graph = Node.create({
  name: "graph",

  group: "block",

  atom: true,

  addAttributes() {
    return {
      graphId: {
        default: null,
      },
      graphNodesJson: {},
      width: {
        default: GRAPH_WIDTH,
      },
      height: {
        default: GRAPH_HEIGHT,
      },
      zoom: {
        default: 100,
      },
      gridType: {
        default: 0,
      },
      gridColor: {
        default: "gray-200",
      },
      bgColor: {
        default: undefined,
      },
      axesColor: {
        default: "black",
      },
      axisLabels: {
        default: false,
      },
      xAxisLabel: {
        default: undefined,
      },
      yAxisLabel: {
        default: undefined,
      },
      coordsSystem: {
        default: undefined,
      },
      axesVisible: {
        default: true,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "block-graph",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["block-graph", mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      appendGraph:
        (position, attrs) =>
        ({ commands, state }) => {
          return commands.insertContentAt(
            position !== undefined ? position : state.selection.$to.end(1),
            {
              type: this.name,
              attrs,
            },
          );
        },
    };
  },
});
